import React, { useEffect, useState } from 'react';
import AuthContext from '../auth/AuthContext';
import { useHistory, useParams } from 'react-router-dom';
import { CooperativaDTO, PageMode, UserDTO, UserRole } from '../common/Dtos';
import { toast } from 'react-toastify';
import { SButton, SDialogButton, SInputLabel, SPanelContainer, STitleContainer, STitleH3, STitleH4 } from '../common/BCommonComponents';
import { FormControl, Grid, MenuItem, Select, Table, TableBody, TableContainer, TextField } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { HeadCell, STableCell, STableHeader, STableRow } from '../common/ScrivaniaTable';
import ConfirmAlertDialog from '../common/ConfirmDialogComponents';
import { AlertDialogContext } from '../common/AlertDialog';

type DettaglioCooperativaParameters = {
	id: string
}

export function DettaglioCooperativa() {
	const auth = React.useContext(AuthContext);
	const alert = React.useContext(AlertDialogContext);
	const param = useParams<DettaglioCooperativaParameters>();
	const history = useHistory();

	const operatoriHeadCells: HeadCell[] = [
		{id: 'firstname', numeric: false, disablePadding: false, label: 'NOME', sortable: true},
		{id: 'lastname', numeric: false, disablePadding: true, label: 'COGNOME', sortable: true},
		{id: 'action', numeric: false, disablePadding: false, label: '', sortable: false}
	];
	const [cooperativa, setCooperativa] = useState<CooperativaDTO>({
		id: '',
		name: '',
		supervisor: '',
		responsible: ''
	});
	const [mode, setMode] = useState(param.id ? PageMode.EDIT : PageMode.NEW);
	const [errorName, setErrorName] = useState<boolean>(false);
	const [operatoriList, setOperatoriList] = useState<UserDTO[]>([]);
	const [deleteModalVisible, setDeleteModalVisible] = useState(false);
	const [modalMessage, setModalMessage] = useState<string>('');

	useEffect(() => {
		if (param.id) {
			getCooperativa();
			getOperatori();

		}
	}, []);

	const getCooperativa = () => {
		auth.state.axiosInstance?.get('/api/cooperativa/cooperativa_by_id/' + param.id)
			.then(res => {
				setCooperativa(res.data);
				// setFilteredPrestazioniConfigAllList(res2?.data);
			}).catch(error => {
			toast.error('🛑 Errore durante il recupero della Cooperativa!');
			console.log(error);
		});
	}

	const getOperatori = () => {
		auth.state.axiosInstance?.get('/api/accounts/operatori_by_cooperativa/' + param.id)
			.then(res => {
				setOperatoriList(res.data)
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero degli Operatori!');
				console.log(error);
			})
	}

	const handleNomeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const newCoop: CooperativaDTO = {
			...cooperativa,
			name: event.target.value
		}

		setCooperativa(newCoop);
	};

	const supervisori = (): UserDTO[] => {
		return operatoriList.filter(op => op.authorities.find(r => r === UserRole.SUPERVISOR));
	}

	const responsabili = (): UserDTO[] => {
		return operatoriList.filter(op => op.authorities.find(r => r === UserRole.RESPONSIBLE));
	}

	const handleDettaglioClick = (user: UserDTO) => {
		history.push("/dettaglio/operatore/" + user.id);
	};

	const handleSaveCooperativa = () => {
		if (cooperativa.name === '') {
			setErrorName(true);
		} else {
			setErrorName(false);

			if (mode === PageMode.NEW) {
				auth.state.axiosInstance?.post('/api/cooperativa/insert',
					{
						...cooperativa
					})
					.then(res => {
						toast.success('Nuova cooperativa creata con successo!');

						setMode(PageMode.EDIT);
						setCooperativa(res.data);
						getOperatori()
						history.push("/dettaglio/cooperativa/" + res.data.id);
					})
					.catch(error => {
						toast.error('🛑 Errore durante il salvataggio della cooperativa');
						console.log(error)
					})
			} else {
				auth.state.axiosInstance?.put('/api/cooperativa/update',
					{
						...cooperativa
					})
					.then(res => {
						toast.success('Modifiche apportate con successo!');
						setCooperativa(res.data);
					})
					.catch(error => {
						toast.error('🛑 Errore durante il salvataggio della cooperativa');
						console.log(error)
					})
			}
		}
	}

	const handleElimina = () => {
		setModalMessage('Sei sicuro di voler procedere con la cancellazione?')
		setDeleteModalVisible(true);
	}

	const closeDeleteModal = () => {
		setDeleteModalVisible(false);
	};

	const confirmDeleteModal = () => {
		setDeleteModalVisible(false);
		auth.state.axiosInstance?.delete('/api/cooperativa/delete/' + cooperativa.id)
			.then(res => {
				toast.success('Cooperativa ' + cooperativa.name + ' eliminata con successo!');
				history.push('/cooperative');
			})
			.catch(error => {
				if (406 === error.response.status) {
					alert.setAlertMessage(error.response.data.message);
					alert.setShowAlert(true);
				} else {
					toast.error('🛑 Errore durante la cancellazione della Cooperativa!');
				}
				console.log(error);
			});
	};

	return (
		<div>
			<STitleContainer>
				<STitleH3> {mode === PageMode.NEW ? "Nuova Cooperativa" : cooperativa?.name} </STitleH3>
			</STitleContainer>
			<Grid container spacing={0} className="w-100">
				<Grid item xs={3} className="pr-2">
					<TextField
						required
						className="w-100"
						id="nome"
						label="Nome"
						variant="outlined"
						InputLabelProps={{shrink: true}}
						value={cooperativa.name ? cooperativa.name : ''}
						onChange={handleNomeChange}
						error={errorName}
					/>
				</Grid>
				<Grid item xs={9} className="d-flex align-items-center justify-content-end">
					<SButton onClick={handleSaveCooperativa}>Salva</SButton>
					{mode === PageMode.EDIT && cooperativa.id !== auth.state.cooperativa &&
					<SButton variant="rosso" onClick={handleElimina}>Elimina</SButton>
					}
				</Grid>
			</Grid>
			{param.id &&
			<React.Fragment>
				<SPanelContainer>
					<STitleH4> SUPERVISORI DELLA COOPERATIVA </STitleH4>
					<TableContainer>
						<Table
							aria-labelledby="tableTitle"
							size={'medium'}
							aria-label="enhanced table">
							<STableHeader
								numSelected={0}
								rowCount={0}
								headCells={operatoriHeadCells}
								addCheckbox={false}
								bgcolor="primary"
								sortable={false}
								disableAction={false}
							/>
							<TableBody>
								{supervisori() &&
								supervisori().map((row, index) => {
									return (
										<STableRow
											hover
											tabIndex={-1}
											key={row.id}
										>
											<STableCell padding="default">{row.firstname}</STableCell>
											<STableCell padding="none">{row.lastname}</STableCell>
											<STableCell padding="none" className="text-center">
												<SDialogButton className="w-50" onClick={() => handleDettaglioClick(row)}>Dettaglio</SDialogButton>
											</STableCell>
										</STableRow>
									);
								})}
							</TableBody>
						</Table>
					</TableContainer>
				</SPanelContainer>
				<SPanelContainer>
					<STitleH4> REFERENTI DI ZONA DELLA COOPERATIVA </STitleH4>
					<TableContainer>
						<Table
							aria-labelledby="tableTitle"
							size={'medium'}
							aria-label="enhanced table">
							<STableHeader
								numSelected={0}
								rowCount={0}
								headCells={operatoriHeadCells}
								addCheckbox={false}
								bgcolor="primary"
								sortable={false}
								disableAction={false}
							/>
							<TableBody>
								{responsabili() &&
								responsabili().map((row, index) => {
									return (
										<STableRow
											hover
											tabIndex={-1}
											key={row.id}
										>
											<STableCell padding="default">{row.firstname}</STableCell>
											<STableCell padding="none">{row.lastname}</STableCell>
											<STableCell padding="none" className="text-center">
												<SDialogButton className="w-50" onClick={() => handleDettaglioClick(row)}>Dettaglio</SDialogButton>
											</STableCell>
										</STableRow>
									);
								})}
							</TableBody>
						</Table>
					</TableContainer>
				</SPanelContainer>
			</React.Fragment>
			}
			<ConfirmAlertDialog
				open={deleteModalVisible}
				onCancel={closeDeleteModal}
				onConfirm={confirmDeleteModal}
				message={modalMessage}
			/>
		</div>
	);
}
